import { z } from "zod";

export const ScoreBands = ["Low", "Medium", "High"] as const;
export const ScoreBandSchema = z.enum(ScoreBands);
export type ScoreBand = z.infer<typeof ScoreBandSchema>;

export const MAX_SUPPORTED_SCALE = 9;

const DEFAULT_SCALE = 5;

export function resolveScale(points: readonly { point: number }[]): number {
    if (points.length === 0) {
        return DEFAULT_SCALE;
    }

    return clampScale(Math.max(...points.map(({ point }) => point)));
}

export function clampScale(scale: number | undefined): number {
    if (scale === undefined || !Number.isSafeInteger(scale)) {
        return DEFAULT_SCALE;
    }

    return Math.min(Math.max(scale, 1), MAX_SUPPORTED_SCALE);
}

const MIN_SCALE = 1;
const LOW_HIGH_CUTOFF_PERCENTAGE = 0.22;

export interface BandCutoffs {
    lower: number;
    upper: number;
}

export function getBandCutoffs(maxScale: number): BandCutoffs {
    const spread = (maxScale - MIN_SCALE) * LOW_HIGH_CUTOFF_PERCENTAGE;

    return { lower: MIN_SCALE + spread, upper: maxScale - spread };
}

export function resolveScoreBand(score: number, maxScale: number): ScoreBand {
    const { lower, upper } = getBandCutoffs(maxScale);

    if (score < lower) {
        return "Low";
    }

    return score < upper ? "Medium" : "High";
}
